'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/auth0-lock/~/react/react.js
// module id = 6
// module chunks = 0